export namespace TariffElementActions {

    export class DownloadFile {
        static readonly type = 'TariffElementActions.DownloadFile';
    }

    export class UploadFile {
        static readonly type = 'TariffElementActions.UploadFile';

        constructor(public hash: string) {
        }
    }

    export class ImportDate {
        static readonly type = 'TariffElementActions.ImportDate';
    }
}
